import * as Sentry from '@sentry/react'
import { createRouter, RouterProvider } from '@tanstack/react-router'

import { FullScreenSpinner } from '@/components/elements'
import { useAuth } from '@/features/auth/hooks'
import { NotfoundPage } from '@/features/shared/components'
import { routeTree } from '@/routeTree.gen'

import { queryClient } from './libs/react-query/query-client'
import { DefaultErrorPage } from './routes/_protected/-components'

const router = createRouter({
  routeTree,
  context: {
    auth: {
      isAuthenticated: false,
      // 認証後のルートでのみで参照する想定なので、non-null assertion operator を使用してる
      user: null!
    },
    queryClient
  },
  defaultPendingComponent: FullScreenSpinner,
  defaultNotFoundComponent: NotfoundPage,
  defaultErrorComponent: DefaultErrorPage
})

Sentry.addIntegration(Sentry.tanstackRouterBrowserTracingIntegration(router))

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
  interface StaticDataRouteOption {
    // Headerのstickyを有効にするかどうか
    stickyHeader?: boolean
  }
}

export function AppRouter() {
  const auth = useAuth()
  return <RouterProvider router={router} context={{ auth }} />
}
